import React from 'react';
import 'components/transactionEditor/Wizards/BzmTreeTable.css';
import MaterialTable, { Column } from 'material-table';
import i18n from '../../../i18n';

type BzmTreeTableProps = {
  data: any[];
  columns: Column<any>[];
  parentChildData: (row: any, rows: any) => void;
  selectedRow?: any;
};

const BzmTreeTable = (props: BzmTreeTableProps) => {
  return (
    <div className={'bzmTreeTable'}>
      <MaterialTable
        localization={{
          toolbar: {
            searchPlaceholder: i18n.t('transactions:editor.search'),
          },
        }}
        style={{
          padding: '1px',
          backgroundColor: '#F0F5FC',
          marginBottom: '3%',
        }}
        title=""
        data={props.data}
        columns={props.columns}
        parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
        options={{
          selection: false,
          filtering: false,
          paging: false,
          sorting: false,
          debounceInterval: 600,
          defaultExpanded: false,
          searchFieldStyle: {
            border: '1px solid #afbacc',
            paddingLeft: '5px',
            fontSize: '14px',
            width: '100%',
            borderRadius: '3px',
          },
          headerStyle: {
            color: '#333840',
            fontSize: '14px',
            fontWeight: 'bold',
            borderTop: '1px solid #c8d1e0',
            borderBottom: '2px solid #c8d1e0',
            width: '23px',
            maxWidth: '23px',
          },
          rowStyle: (rowData: any) => ({
            backgroundColor: props.selectedRow === rowData.tableData.id && rowData.type === 'LEAF' ? '#F0F5FC' : '#FFF',
            cursor: rowData.type === 'LEAF' ? 'pointer' : 'auto',
            width: '23px',
            maxWidth: '23px',
          }),
          draggable: false,
          toolbar: true,
          searchFieldAlignment: 'right',
          showSelectAllCheckbox: false,
          selectionProps: (rowData: any) => ({
            color: 'primary',
            disabled: rowData.type === 'NODE',
          }),
          actionsColumnIndex: -1,
        }}
      />
    </div>
  );
};

export default BzmTreeTable;
